import { Link } from "react-router-dom";
import { characters } from "@/mocks/characters";
import { works } from "@/mocks/works";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useJsonLd } from "@/hooks/useJsonLd";

export default function Works() {
  usePageMeta(
    "作品库｜女神漫画角色所属作品大全",
    "女神漫画角色图鉴作品库按作品分类整理女神角色，涵盖奇幻恋爱、和风神话、西幻圣域、都市奇幻与海洋神话五大谱系，帮你按作品快速浏览角色大全。"
  );

  useJsonLd(
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "女神漫画角色作品库",
      itemListElement: works.map((w, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: w.title,
        description: w.description,
      })),
    },
    "works"
  );

  return (
    <>
      <section className="relative flex min-h-[260px] md:min-h-[300px] w-full items-center overflow-hidden bg-foreground-950">
        <img
          src="https://readdy.ai/api/search-image?query=five%20distinct%20goddess%20realms%20floating%20across%20a%20glowing%20sky%20each%20with%20its%20own%20color%20theme%2C%20wide%20fantasy%20anime%20banner%2C%20warm%20amber%20crimson%20gold%20and%20teal%20palette%2C%20luminous%20celestial%20atmosphere&width=1600&height=600&seq=works-banner-2026&orientation=landscape"
          alt="作品库横幅背景"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pt-16 pb-8 text-white md:pt-24">
          <nav aria-label="面包屑" className="text-xs text-white/70">
            <span className="hover:text-white"><a href="/" rel="nofollow">首页</a></span>
            <span className="mx-2">/</span>
            <span>作品库</span>
          </nav>
          <h1 className="mt-4 font-heading text-3xl font-black md:text-5xl">作品库</h1>
          <p className="mt-4 max-w-2xl text-sm text-white/80 md:text-base">
            按所属作品分类整理的女神角色大全。从奇幻恋爱到海洋神话，选择一部作品，走进它的女神谱系。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="space-y-12 md:space-y-16">
            {works.map((w, idx) => {
              const list = characters.filter((c) => c.workId === w.id);
              return (
                <article
                  key={w.id}
                  className={`grid gap-6 md:gap-8 lg:grid-cols-12 ${idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
                >
                  <div className="lg:col-span-4">
                    <div className="group relative overflow-hidden rounded-lg">
                      <div className="aspect-[16/10] overflow-hidden">
                        <img
                          src={w.cover}
                          alt={`${w.title} 作品封面`}
                          className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
                        {w.category}
                      </span>
                    </div>
                  </div>

                  <div className="lg:col-span-8">
                    <div className="flex flex-wrap items-center gap-3">
                      <h2 className="font-heading text-xl font-bold md:text-2xl">{w.title}</h2>
                      <span className="text-xs text-foreground-500">{w.year} · {w.theme}</span>
                    </div>
                    <p className="mt-1 text-sm text-primary-600">{w.subtitle}</p>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600">{w.description}</p>

                    <h3 className="mt-6 text-sm font-semibold text-foreground-800">
                      收录女神 · <span className="text-primary-600">{list.length}</span> 位
                    </h3>
                    <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
                      {list.map((c) => (
                        <Link
                          key={c.id}
                          to={`/character/${c.id}`}
                          className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-100 p-2.5 transition-colors hover:border-primary-300 hover:bg-background-50"
                        >
                          <span className="flex h-12 w-9 shrink-0 overflow-hidden rounded-md">
                            <img src={c.image} alt={`${c.name} 头像`} className="h-full w-full object-cover object-top" />
                          </span>
                          <span className="min-w-0">
                            <span className="block truncate text-sm font-semibold text-foreground-900">{c.name}</span>
                            <span className="block truncate text-xs text-foreground-500">{c.epithet}</span>
                          </span>
                        </Link>
                      ))}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}